import { useState, useEffect } from "react";
import "./LifeSkillCourses.css";
// import  leftimg from "../assets/Lifeleftimg.png"
// import rightimg from "../assets/Stemrightimg.png"

import Testimonials from "../MyComponents/Testimonials"
import FAQ from "../MyComponents/FooterPages/newfaq.js"
import { Link } from "react-router-dom"
// import Navbar from "../MyComponents/Navbars/GuestNav"
import Footer from "../MyComponents/Footer"
import heroContent from './StemCourses/HeroContent.js';
import API_CONFIG from "../config/api";

import PopularCourses from "../MyComponents/PopularCourses";
import "./SummerCamp.css";


// import Testimonials from "../components/Testimonials"
import Hero2 from "../MyComponents/Hero2.js"
import CertificateVerification from "../MyComponents/CertificateVerification";
//  import leftimgs from "../assets/boy-with-laptop.png"
//  import rightimgs from "../assets/kids-on-book.png"
//  import info1 from "../assets/Clip path group.png"
//  import info2 from "../assets/IMG_5467 2.png"
//  import info3 from "../assets/Menu Pages/Mask group.png"
//  import info4 from "../assets/Group.png"
// import info5 from "../assets/Clip path group-1.png"
// import info6 from "../assets/Menu Pages/Group-1.png"
// import info7 from "../assets/Menu Pages/q (4).png"
// import imgno8 from "../assets/Menu Pages/Group-4.png"
// import info9 from "../assets/Menu Pages/Group-2.png"
import SumCourses from "./SumCourses.js";
// import pencilIcon from "../assets/pencil.png";
import AdvantagesSection from "../MyComponents/PromotionalPages/AdvantagesSection.js";
import HeadSection from "./HeadSection.js";
import { Helmet } from "react-helmet";
import GallerySection from "../MyComponents/GallerySection";


const LifeSkillCourses = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    // Ensures Comic Sans is loaded (will be handled by @import in CSS)
  }, []);
  const Stemcoursespage = heroContent.StemSection;
  if (!Stemcoursespage) {
    return <div>Error: Hero content not found.</div>;
  }
  const advantages = [
    {
      imgSrc: "Polymath-images/Menu Pages/Features/Clip path group.png",
      alt: "Live Classes",
      title: "Hands-On Learning",
      text: "Kids build real projects that ignite creativity and innovation.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Features/IMG_5467 2.png",
      alt: "Global Access",
      title: "STEM.Org Certified",
      text: "Benefit from a trusted, globally recognized curriculum.",

    },
    {
      imgSrc: "Polymath-images/Menu Pages/Mask group.png",
      alt: "Wide Course Variety",
      title: "Expert Teachers",
      text: "Learn from experienced partners passionate about education.",

    },
    {
      imgSrc: "Polymath-images/Menu Pages/Features/Group-1.png",
      alt: "Fast-Track Format",
      title: "Age-Appropriate",
      text: "Courses designed to suit every age group and learning style.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Features/Clip path group-1.png",
      alt: "Certified Completion",
      title: "Flexible & Online Learning",
      text: "Access learning anytime, anywhere, on your schedule.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Features/Group-1.png",
      alt: "Fun + Education",
      title: "21st-Century Skills",
      text: "Develop leadership, teamwork, and problem-solving abilities.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Features/Group-2.png",
      alt: "Age-Specific Programs",
      title: "Global Community",
      dtext: "Join our global community of young learners!",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Features/Clip path group-3.png",
      alt: "Confidence Building",
      title: "Confidence Building",
      text: "Hands-on projects and past experiences.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Features/Group-3.png",
      alt: "Big Summer Discounts",
      title: "Curriculum Integration",
      text: "Blend learning with STEM+, coding, and interactive tools.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>STEM Courses for Kids | Coding, Math & Creative Learning -- Polymath-Kids</title>
        <meta name="description" content="Explore top-rated STEM courses at Polymath-Kids. Hands-on coding, math & technology programs that build problem-solving, creativity & 21st-century skills." />
      </Helmet>
      {/* <Navbar/> */}
      <HeadSection
        leftImg={"Polymath-images/Menu Pages/Group 1686552055.png"}
        rightImg="Polymath-images/Menu Pages/Summer/Frame 1686552031.png"
        titlePart1="Explore Our Top-Rated"
        titlePart2="Stem Courses"
        description="Empower young minds with essential problem-solving skills through engaging courses in math, coding, and technology. These hands-on programs foster creativity, critical thinking, and a strong foundation in STEM subjects."
        button1Text={false}
        button2Text="Book Free Demo Class"
        button1Icon="Polymath-images/Menu Pages/Clip path group.png"
        button2Icon="Polymath-images/Menu Pages/Clip path group.png"
        onButton1Click={() => alert("Early bird discount clicked!")}
        onButton2Click={() => alert("Book demo clicked!")}
      />

      <div className="index-root">

        {/* Left side decorative image */}
        {/* <div className="left-img">
        <img
          src={leftimg}
          alt="Decorative calculator and supplies"
          style={{ width: "200px", objectFit: "contain" }}
          onLoad={() => setIsImageLoaded(true)}
        />
      </div> */}


        {/* Main content container */}
        <div className="index-container">
          <AdvantagesSection
            advantages={advantages}
            heading={"Advantages of Courses from"}
            subheading={"PolyMath Kids"}
          />




          {/* CTA Button with character illustration */}
          <div className="cta-row">
            <div className="cta-char">
              <div
                className="cta-char-inner"
              // style={{
              //   backgroundImage:
              //     'url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' viewBox=\'0 0 100 100\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Ccircle cx=\'50\' cy=\'40\' r=\'20\' fill=\'%233F51B5\'/%3E%3Crect x=\'35\' y=\'65\' width=\'30\' height=\'35\' fill=\'%233F51B5\'/%3E%3C/svg%3E")',
              // }}
              ></div>
            </div>
            <button className="lcustom-btn yellow-btn">
              <img src={`${API_CONFIG.IMAGES_URL}/Polymath-images/Menu Pages/Clip path group.png`} alt="icon" className="lbtn-icon" />
              Book Free Demo Class
            </button>
          </div>
        </div>
        <PopularCourses />
        {/* <CertificateVerification/>  */}


      </div>
      <Testimonials />
      <FAQ />
      {/* <section className="gallery-section">
              <div className="container">
                <div className="gallery-header">
                  <h2 className="gallery-title">
                    <span className="gallery-of">Gallery of </span>
                    <span className="learning-growth">Learning & Growth</span>
                  </h2>
                  <div className="sun-icon">
                    <img src={require("../assets/sun.png")} alt="Sun" />
                  </div>
                </div>
    
                <div className="gallery-grid">
                  {[...Array(8)].map((_, i) => (
                    <div className="gallery-item" key={i}>
                      <img
                        src={
                          require(`../assets/kid${i + 7}.png`) || "/placeholder.svg"
                        }
                        alt="Learning child"
                      />
                    </div>
                  ))}
                </div>
    
                <div className="calculator-icon">
                  <img src={require("../assets/calculator.png")} alt="Calculator" />
                </div>
    
                <div className="gallery-button">
                  <Link to="/gallery">
                    <img
                      src={require("../assets/viewgallery.png")}
                      alt="View Gallery"
                    />
                  </Link>
                </div>
              </div>
            </section> */}
      <div>
        <GallerySection />
      </div>
      <Footer />
    </>
  );
};

export default LifeSkillCourses;